import { z } from 'zod';
import { ActorSchema } from '../common/actor.schema';
import { CAPTURE_FINDING_ANSWER_VALUES, PropertyCaptureViewingKindSchema } from '../property/property-capture.schemas';

export const PropertyCaptureStartedPayloadSchema = z.object({
  captureId: z.uuid(),
  propertyId: z.uuid(),
  workspaceId: z.uuid(),
  viewingKind: PropertyCaptureViewingKindSchema,
  actor: ActorSchema,
  occurredAt: z.iso.datetime(),
});
export type PropertyCaptureStartedPayload = z.infer<typeof PropertyCaptureStartedPayloadSchema>;

/** Carries no value: the fact row is the record, and the audit entry says who changed which field. */
export const PropertyCaptureFindingRecordedPayloadSchema = z.object({
  captureId: z.uuid(),
  propertyId: z.uuid(),
  workspaceId: z.uuid(),
  factKey: z.string().min(1),
  occurrence: z.string().nullable(),
  answer: z.enum(CAPTURE_FINDING_ANSWER_VALUES),
  actor: ActorSchema,
  occurredAt: z.iso.datetime(),
});
export type PropertyCaptureFindingRecordedPayload = z.infer<typeof PropertyCaptureFindingRecordedPayloadSchema>;

/** Carries no photo: the row and its motif are the record, the audit entry says who took it. */
export const PropertyCapturePhotoAddedPayloadSchema = z.object({
  captureId: z.uuid(),
  propertyId: z.uuid(),
  workspaceId: z.uuid(),
  capturePhotoId: z.uuid(),
  motifId: z.string().min(1),
  actor: ActorSchema,
  occurredAt: z.iso.datetime(),
});
export type PropertyCapturePhotoAddedPayload = z.infer<typeof PropertyCapturePhotoAddedPayloadSchema>;

/** One per completion: the row keeps only the latest, the audit trail keeps every one with its counts. */
export const PropertyCaptureCompletedPayloadSchema = z.object({
  captureId: z.uuid(),
  propertyId: z.uuid(),
  workspaceId: z.uuid(),
  viewingKind: PropertyCaptureViewingKindSchema,
  completedAt: z.iso.datetime(),
  openRequiredFieldCount: z.number().int().nonnegative(),
  openRequiredPhotoCount: z.number().int().nonnegative(),
  actor: ActorSchema,
  occurredAt: z.iso.datetime(),
});
export type PropertyCaptureCompletedPayload = z.infer<typeof PropertyCaptureCompletedPayloadSchema>;
